import fetch from 'isomorphic-fetch';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {commonHeaders} from '../../actions/fetch.util';
import Login from '../Common/Login';
import {Button} from '../Common/PageComponents';
import HeaderMenu from '../Common/HeaderMenu';

import './PcBangPointAgreement.scss';

const stateToProps = state => {
  return {
    user: state.user,
  };
};

class PcBangPointAgreement extends Component {
  constructor(props, context) {
    super(props, context);
    this.type = 'point-product';
    this.state = {agreed: false, agreementCheckbox: false};
  }

  submit(type) {
    if (this.state.agreementCheckbox) {
      fetch(`${API_URL}/agreement/current-user`, {
        method: 'POST',
        headers: commonHeaders(),
        body: JSON.stringify({
          type: type,
        }),
      }).then(response => {
        if (response.status === 409) {
          this.setAgreed();
        } else if (response.status === 201) {
          this.setAgreed();
        } else {
          alert('오류가 발생했습니다.');
        }
      });
    } else {
      alert('동의 후 제출해주십시요.');
    }
  }

  setAgreed() {
    this.setState({agreed: true});
  }

  getAgreement(type) {
    fetch(`${API_URL}/agreement/current-user/type/${type}`, {
      method: 'GET',
      headers: commonHeaders(),
    }).then(response => {
      if (response.status === 404) {
        this.setState({agreed: false});
      } else if (response.status === 200) {
        this.setAgreed();
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.username !== this.props.user.username) {
      this.getAgreement(this.type);
    }
  }

  onChangeAgreementCheckbox = () => {
    this.setState(prevState => ({agreementCheckbox: !prevState.agreementCheckbox}));
  };

  render() {
    return (
      <div className="agreement-page">
        <HeaderMenu />
        <div>
          <h1 className="agreement-page__title">
            라이엇 게임즈 프리미엄 PC방 통합 포인트제 상품 안내 <br /> 및 통합 과금에 대한 동의
          </h1>
          {this.props.user.username
            ? this.state.agreed
              ? this.renderAgreementDone()
              : this.renderAgreement()
            : this.renderLogin()}
        </div>
      </div>
    );
  }

  renderLogin() {
    return (
      <div className="content">
        <div>
          라이엇 게임즈 프리미엄 PC방 통합 포인트제 상품 안내 및 통합 과금에 대한 동의가 시작되었습니다. 동의를 위해서는
          리그 오브 레전드 프리미엄 PC방 ID/PW로 로그인이 필요합니다.
        </div>
        <div className="payback">
          발로란트 정식 서비스 전 동의를 진행하실 경우, 정식 서비스 시점부터 30일간 발로란트 게임에서 소진된 포인트에
          대한 페이백 혜택을 받으실 수 있습니다.
        </div>
        <Login />
      </div>
    );
  }

  renderAgreement() {
    return (
      <div className="content">
        <div style={{color: '#000'}}>로그인 ID: {this.props.user.username}</div>
        <div style={{fontSize: '12px', marginTop: '20px'}}>
          각 PC방 사업자는 라이엇 서비스를 제공받기 위해서 포인트 구매가 필요합니다.
          <br />
          포인트는 라이엇 게임즈 프리미엄 PC방 사이트에서 사용하실 수 있는 모든 게임에서 사용 가능한 통합 포인트로, 구매
          시 등록하신 모든 IP에 자사가 서비스 중인 모든 게임에 가입하신 것으로 간주, 각 게임의 플레이 권한 및 프리미엄
          PC방 혜택이 시작됩니다. 단, 사업자는 언제든지 원하지 않는 게임에 대해 PC방 사이트 내에서 직접 해지하실 수
          있습니다. <br />
          <br />
          포인트(pt)란?
          <br />
          라이엇 게임즈 프리미엄 PC방 사이트에서 이용할 수 있는 통합 상품으로, 서비스 중인 모든 게임은 포인트 충전 후
          이용하실 수 있으며, 포인트 별 이용 시간은 게임별로 상이합니다. 포인트는 신용카드, 계좌이체, 가상계좌(일반 결제
          전용)로 구매하실 수 있습니다.
          <br /> <br />
          라이엇 서비스란?
          <br />
          “라이엇서비스”는 유료서비스로 본 약관에 의해 허용되는 사업자에게만 제공되는 서비스입니다. 이는 Riot Games,
          Inc.에서 개발하고, “라이엇 게임즈”가 서비스하는 게임(이하 “게임”)과 관련된 “라이엇 게임즈 프리미엄 PC방
          서비스”를 의미합니다. 해당 서비스는 사업자의 사업장에 방문하는 이용자가 “게임”플레이를 할 수 있도록 “라이엇
          게임즈”가 허용하는 것과 사업자가 “라이엇 게임즈”에게 각 “게임”별 추가 요금을 지불함으로써 얻게 되는 “프리미엄
          PC방 서비스” 를 의미합니다.
        </div>
        <div className="agreement-page__checkbox">
          <label>
            <input type="checkbox" onChange={this.onChangeAgreementCheckbox} checked={this.state.agreementCheckbox} />{' '}
            위 서비스의 내용을 명확히 읽고 이해하였으며 포인트 통합 과금에 동의합니다.
          </label>
        </div>
        <div style={{textAlign: 'center', marginTop: '20px'}}>
          <Button onClick={() => this.submit(this.type)}>제출</Button>
        </div>
      </div>
    );
  }

  renderAgreementDone() {
    return (
      <div className="content agreement-done">
        라이엇 게임즈 프리미엄 PC방 통합포인트 통합 과금에 대한 동의가 완료 되었습니다.
        <div className="payback">
          발로란트 정식 서비스 시점부터 30일간 발로란트 게임에서 소진된 포인트에 대한 페이백 혜택을 받으실 수 있습니다.
        </div>
        <Login />
      </div>
    );
  }
}

export default connect(stateToProps)(PcBangPointAgreement);
